import { Alert } from '../_functions'
import $ from 'jquery'

const object = vnObject

document.addEventListener('DOMContentLoaded', function(dom) {
    const object = vnObject

    const form = dom.target.querySelector('.registration-form')

    if (form) {

        form.addEventListener('submit', function(e) {
            e.preventDefault()
            e.stopPropagation()

            if (form.checkValidity()) {
                const formData = new FormData(form)
                formData.append('action', 'vn_registration')

                const options = {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Accept: 'application/json',
                    },
                }

                fetch(object.ajaxUrl, options)
                    .then((response) => response.json())
                    .then((res) => {
                        form.classList.remove('sending')

                        /*if (res.success && res.data.redirect) {
                          window.location = res.data.redirect
                        }*/

                        Alert(res.success, res.data.message)

                        if (res.success) {
                            form.reset()
                        }
                    })
                    .catch((error) => {
                        form.classList.remove('sending')
                        console.error('Erreur:', error)
                    })

                form.classList.add('sending')
                Alert(false, object.formWait)
            } else {
                form.classList.add('was-validated')
            }
        })
    }
})


const $trainingSelect = $('.js-registration-training-select')
const $sessionSelect = $('.js-registration-session-select')

const updateSessionSelect = () => {
    const trainingId = String($trainingSelect.val() || '')
    const trainingsAndDates = object.trainings_and_dates || {}
    const sessions = trainingsAndDates[trainingId] || []

    $sessionSelect.empty()

    if (!trainingId) {
        $sessionSelect
            .append(
                $('<option>', {
                    value: '',
                    text: object.session_placeholder,
                }),
            )
            .prop('disabled', true)

        return
    }

    if (!sessions.length) {
        $sessionSelect
            .append(
                $('<option>', {
                    value: '',
                    text: object.no_session,
                }),
            )
            .prop('disabled', true)
        $sessionSelect.parent().append('<p>'+ object.no_session_info +'</p>')
        return
    }

    $sessionSelect.append(
        $('<option>', {
            value: '',
            text: object.session_placeholder,
        }),
    )

    sessions.forEach((session) => {
        $sessionSelect.append(
            $('<option>', {
                value: session.id,
                text: session.title,
            }),
        )
    })

    if (object.selected_training_date) {
        $sessionSelect.val(String(object.selected_training_date))
        object.selected_training_date = ''
    }

    $sessionSelect.prop('disabled', false)
}

$trainingSelect.on('change', updateSessionSelect)

// Initialise les sessions si une formation est déjà sélectionnée.
updateSessionSelect()


const billingCollapse = document.querySelector('#collapseBillingFields')
const $hasDiffBilling = $('#has_diff_billing')

const $billingFields = $(billingCollapse).find(
    'input:not([type="checkbox"]), select, textarea',
)

const updateBillingFields = (isOpen) => {
    $hasDiffBilling.prop('checked', isOpen)
    $billingFields.prop('required', isOpen)

    if (!isOpen) {
        // Supprime les erreurs visuelles lorsque l'accordéon est refermé.
        $billingFields.removeClass('is-invalid')
    }
}

if ( billingCollapse ) {
    billingCollapse.addEventListener('show.bs.collapse', () => {
        updateBillingFields(true)
    })

    billingCollapse.addEventListener('hide.bs.collapse', () => {
        updateBillingFields(false)
    })


// Initialisation au chargement de la page.
    updateBillingFields(billingCollapse.classList.contains('show'))
}
